import { render } from "./TamUngLuongAdmin.vue?vue&type=template&id=02708630&scoped=true"
import script from "./TamUngLuongAdmin.vue?vue&type=script&lang=js"
export * from "./TamUngLuongAdmin.vue?vue&type=script&lang=js"

import "./TamUngLuongAdmin.vue?vue&type=style&index=0&id=02708630&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02708630"]])

export default __exports__